import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";


interface BatchItem {
  user_email: string;
  batch_id: string;
  library_name: string;
  group_name: string;
  run_id: string;
  workflow_round: number;
  batch_status: string;
}

interface UserBatchInfo {
  total_running_batches: number;
  batches: BatchItem[];
}

export interface iWorkingBatchListState {
  isLoading: boolean;
  response: {
    total_running_batches: number;
    users: Record<string, UserBatchInfo>;
  };
  message: string;
}

const initialState: iWorkingBatchListState = {
  isLoading: false,
  response: {
    total_running_batches: 0,
    users: {},
  },
  message: "",
};

export const getWorkingBatchListAPI = createAsyncThunk<
    { total_running_batches: number; users: Record<string, unknown> },
    void,
    { rejectValue: string }
>(
    'WORKING_BATCH_LIST_API',
    async (_, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/auth/working-batch-list/'

            const response = await axiosInstance.get(
                `${djangoEndpoint}${pathParam}`,
                {
                    withCredentials: true,
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

const workingBatchListSlice = createSlice({
    name: "confirmActiveUser",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(getWorkingBatchListAPI.pending, (state) => {
          state.isLoading = true;
          state.message = "";
        })
        .addCase(getWorkingBatchListAPI.fulfilled, (state, action) => {
          state.isLoading = false;
          state.response = {
            total_running_batches: action.payload.total_running_batches ?? 0,
            users: action.payload.users as Record<string, UserBatchInfo> ?? {},
          };
        })
        .addCase(getWorkingBatchListAPI.rejected, (state, action) => {
          state.isLoading = false;
          state.message = action.payload ?? "Failed to fetch working batch list";
        });
    },
  });
  
  export default workingBatchListSlice.reducer;